import { z } from 'zod';

export const partnerIdentifierSchema = z.object({
  Created: z.date(),
  PartnerIdentifier: z.string(),
  idPartner: z.number(),
  idRelationship: z.number(),
  idRelationshipPartner: z.number(),
});

export type IPartnerIdentifierSchema = z.infer<typeof partnerIdentifierSchema>;
